var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"px-0 mb-7 pl-5"},[_c('InputGenericRadioOption',{attrs:{"id":"input-single-choice","model":_vm.$v.entry.answer,"options":_vm.computedChoices,"submissionStates":_vm.submissionStates,"error":_vm.$t('FORMS.GENERIC_ERRORS.REQUIRED'),"displayLabel":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }